import React, { useState } from 'react'

import { Input } from '../..'

export const InputStandard = ({
  name,
  label,
  variant,
  hide,
  mask,
  disabled,
  error,
  register,
  keyboard,
  ...rest
}) => {
  const [isHidden, setIsHidden] = useState(hide)

  return (
    <Input.Root size={variant} hide={hide}>
      <Input.Area
        {...rest}
        {...register(name)}
        id={name}
        hasError={!!error}
        mask={mask}
        hide={isHidden}
        keyboard={keyboard}
        disabled={disabled}
      />
      <Input.Label text={label} hasError={!!error} htmlFor={name} />
      <Input.Span text={error} />
      <Input.PasswordIcon hide={hide} onChange={setIsHidden} />
    </Input.Root>
  )
}
